// extracted by mini-css-extract-plugin
export default {"root":"Gg9NVdmfi0ktg_xtQh8I","pencil":"w6Gm4HvqT5lNIb4l8JgW"};